import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="text-sm">
      <ol className="flex items-center flex-wrap gap-1">
        <li className="flex items-center">
          <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
            <i className="ri-home-4-line"></i>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            {item.path ? (
              <Link
                to={item.path}
                className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-950 font-medium whitespace-nowrap">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}